import React from 'react'
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import Api from "../../services/Api";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faHashtag, faTimes } from '@fortawesome/free-solid-svg-icons';

class Editar extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        load: '',
        datosCargados: false,
        municipio: [],
        departamentosVisita: [],
        comercializadores: [],
        errores: []
    }
    cambioValor = (e) => {
        const state = this.state.municipio;
        state[e.target.name] = e.target.value;
        this.setState({ municipio: state });
    };
    verificarError(elemento) {
        return this.state.errores.indexOf(elemento) !== -1;
    }
    enviarDatos = (e) => {
        e.preventDefault();
        const nombre = document.getElementById('nombre').value;
        const id_municipio = document.getElementById('id_municipio').value;
        const id_departamento = document.getElementById('ID_DEPARTAMENTO').value;
        const id_comercializador = document.getElementById('ID_COMERCIALIZADOR').value;
        var errores = [];
        if (!nombre) { errores.push("error_nombre"); }
        if (!id_municipio) { errores.push("error_id_municipio"); }
        if (!id_comercializador) { errores.push("error_id_comercializador"); }
        if (!id_departamento) { errores.push("error_id_departamento"); }
        this.setState({ errores: errores });
        if (errores.length > 0) {
            return false;
        }
        let form = document.getElementById('form');
        let formData = new FormData(form);
        console.log(formData);
        Swal.showLoading();
        authAxios.post("municipios_comercializadores/editar", formData)
            .then((datosRespuesta) => {
                console.log(datosRespuesta)
                Swal.close();
                Swal.fire(
                    'Municipios Comercializadoras!',
                    datosRespuesta.data.msj,
                    'success'
                )
                this.props.history.push("/MasterMunicipiosComercializadores");
            })
            .catch(console.log)
    }
    componentDidMount() {
        Swal.showLoading();
        authAxios.get("municipios_comercializadores/ver/" + this.props.match.params.id)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                this.setState({ datosCargados: true, municipio: datosRespuesta.data, load: '' });
            })
            .catch(console.log);
        authAxios.get("departamentos_visitas/index/0")
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                this.setState({ datosCargados: true, departamentosVisita: datosRespuesta.data.data, load: '' });
            })
            .catch(console.log);
        authAxios.get("comercializadores/index/0")
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                this.setState({ datosCargados: true, comercializadores: datosRespuesta.data.data, load: '' });
                Swal.close();
            })
            .catch(console.log);
    }
    render() {
        const { load, municipio, departamentosVisita, comercializadores } = this.state;
        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header text-center">
                                {load ? (<b>{load}</b>) : (<b>EDITAR MUNICIPIO COMERCIALIZADORA</b>)}
                            </div>
                            <div className="card-body">
                                <form onSubmit={this.enviarDatos} id="form">
                                    <div className="row">
                                        <div className="col-xl-12">
                                            <div className='row g-3'>
                                                <div className="col-md-6">
                                                    <label htmlFor="ID_COMERCIALIZADOR">Comercializadora</label>
                                                    <select name="ID_COMERCIALIZADOR"
                                                        id="ID_COMERCIALIZADOR"
                                                        value={municipio.ID_COMERCIALIZADOR}
                                                        options={municipio.ID_COMERCIALIZADOR}
                                                        className={((this.verificarError("error_id_comercializador")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.cambioValor}>
                                                        <option value="">Seleccione la Comercializadora</option>
                                                        {
                                                            comercializadores.map((itemComercializadores) => (
                                                                <option key={itemComercializadores.ID_COMERCIALIZADOR} value={itemComercializadores.ID_COMERCIALIZADOR}>{itemComercializadores.NOMBRE}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione la Comercializadora</small>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-3">
                                                    <label htmlFor="ID_DEPARTAMENTO">Departamento</label>
                                                    <select name="ID_DEPARTAMENTO"
                                                        id="ID_DEPARTAMENTO"
                                                        value={municipio.ID_DEPARTAMENTO}
                                                        options={municipio.ID_DEPARTAMENTO}
                                                        className={((this.verificarError("error_id_departamento")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.cambioValor}>
                                                        <option value="">Seleccione el Departamento</option>
                                                        {
                                                            departamentosVisita.map((itemDepartamentosVisita) => (
                                                                <option key={itemDepartamentosVisita.ID_DEPARTAMENTO} value={itemDepartamentosVisita.ID_DEPARTAMENTO}>{itemDepartamentosVisita.NOMBRE}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Departamento</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <input type="hidden" name="id" value={this.props.match.params.id} />
                                                    <label htmlFor="id_municipio">ID. Municipio</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="id_municipio" id="id_municipio" defaultValue={municipio.ID_MUNICIPIO}
                                                            className={((this.verificarError("error_id_municipio")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="ID. MUNICIPIO" aria-describedby="helpId"
                                                            onChange={this.cambioValor}
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el ID. Municipio</small>
                                                </div>
                                                <div className="col-md-4">
                                                    <label htmlFor="nombre">Nombre</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="nombre" id="nombre" defaultValue={municipio.NOMBRE}
                                                        className={((this.verificarError("error_nombre")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="NOMBRE" aria-describedby="helpId"
                                                        onChange={this.cambioValor}
                                                    />
                                                    <small id="helpId" className="invalid-feedback">Digite el Nombre</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className='row'>
                                        <div className='col-xl-12 text-center'>
                                            <div className="btn-group" role="group" aria-label="">
                                                <button type="submit" className="btn btn-primary btn-sm"><FontAwesomeIcon icon={faEdit} />&nbsp;&nbsp;Editar Mpio. Comer.</button>&nbsp;&nbsp;
                                                <Link className="btn btn-danger btn-sm" to={"/MasterMunicipiosComercializadores"}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar</Link>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Editar;